import { jsx as _jsx } from "react/jsx-runtime";
import { Button, mode, useColorMode } from '@abb/uikit';
import Cookies from 'js-cookie';
import React from 'react';
import { useTranslation } from 'react-i18next';
export const Logout = ()=>{
    const { t, i18n } = useTranslation('common');
    const { colorMode } = useColorMode();
    const handleLogOut = ()=>{
        Cookies.remove('access');
        Cookies.remove('access.sig');
        Cookies.remove('refresh');
        Cookies.remove('refresh.sig');
        localStorage.removeItem('videoCallOrderId');
        localStorage.removeItem('videoCallType');
        localStorage.removeItem('promoCodeApi');
        localStorage.removeItem('isModalShowed');
        localStorage.removeItem('selectedCif');
        localStorage.removeItem('phoneNumber');
        localStorage.removeItem('asanId');
        localStorage.removeItem('verificationNumber');
        localStorage.removeItem('sessionIdForAsan');
        localStorage.removeItem('asan-mobile-number');
        localStorage.removeItem('loyalty');
        sessionStorage.clear();
        window.location.href = `/digital-platform/${i18n.language}`;
    };
    return /*#__PURE__*/ _jsx(Button, {
        bg: mode('#0A0B0D0A', '#484A4F')({
            colorMode
        }),
        borderRadius: "12px",
        cursor: "pointer",
        _hover: {
            bg: mode('#FAFAFA', '#292B2E')({
                colorMode
            })
        },
        onClick: handleLogOut,
        w: "100%",
        variant: "gray",
        children: t('actions.logout')
    });
};
